module.exports = __webpack_public_path__ + "img/earphones.318ede6e.jpg";